import React from 'react';
import PropTypes from 'prop-types';

import { useDisclosure, useMediaQuery } from '@mantine/hooks';
import { useMenuManagement } from 'hooks/useMenuManagement';

import { ActionIcon } from '@mantine/core';
import { breakpoints } from 'styles/theme.variables';

import MenuSearchBar from './MenuSearchBar';
import { MenuItemSearchModal } from './MenuItemSearchModal';
import { SearchIconSm } from '@chownow/pantry/icons';

export default function MenuSearch({
  companyId,
  searchTerm,
  menuUuid,
  merchantId,
  setSearchUuid,
  setFilterTerm,
  setSearchLabel,
}) {
  const [modalOpened, { open: openModal, close: closeModal }] = useDisclosure(false);
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);

  const { refreshSingleMenuUpdateSearchTerm } = useMenuManagement();

  const handleSubmit = async ({ uuid, label }) => {
    setSearchUuid(uuid);
    setSearchLabel?.(label);
    await refreshSingleMenuUpdateSearchTerm({
      companyId,
      merchantId,
      menuUuid,
      searchUuid: uuid,
    });
  };

  return (
    <>
      {isMobile ? (
        <ActionIcon
          variant="default"
          size={40}
          radius="sm"
          aria-label="Search menu items"
          onClick={openModal}
          style={{ borderColor: 'var(--border-primary)' }}
        >
          <SearchIconSm />
        </ActionIcon>
      ) : (
        <MenuSearchBar
          searchTerm={searchTerm}
          setFilterTerm={setFilterTerm}
          onSearch={openModal}
        />
      )}
      <MenuItemSearchModal
        opened={modalOpened}
        onClose={closeModal}
        onSubmit={handleSubmit}
        companyId={companyId}
        merchantId={merchantId}
        menuUuid={menuUuid}
        initialSearchText={searchTerm}
      />
    </>
  );
}

MenuSearch.propTypes = {
  companyId: PropTypes.number,
  menuUuid: PropTypes.string,
  merchantId: PropTypes.number,
  searchTerm: PropTypes.string,
  setFilterTerm: PropTypes.func,
  setSearchUuid: PropTypes.func,
  setSearchLabel: PropTypes.func,
};
